var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRetentionTime = function SvgRetentionTime(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1.5a9.474 9.474 0 0 1 6.966 3.041h.054V4.6A9.466 9.466 0 0 1 20.5 11 9.5 9.5 0 1 1 11 1.5zm-.515 1.232a8.284 8.284 0 0 0 0 16.536zm6.236 14.259-5.02-.001.001 2.264a8.254 8.254 0 0 0 5.019-2.263zm1.929-2.808-6.949-.001v1.591h6.07a8.268 8.268 0 0 0 .879-1.59zm.626-2.844-7.575-.001v1.627h7.348a8.283 8.283 0 0 0 .227-1.626zm-.356-2.772-7.219-.001v1.555h7.536a8.243 8.243 0 0 0-.317-1.554zm-1.506-2.81-5.713.001v1.591h6.736a8.291 8.291 0 0 0-1.023-1.591zm-5.712-3.01-.001 1.794h4.486a8.244 8.244 0 0 0-4.485-1.795z",
    fill: "#000",
    fillRule: "nonzero"
  }))));
};

export default SvgRetentionTime;